import {
  isDifferentStatoScommessaByKey,
  isEqualStatoScommessaByKey,
  retrieveImageGiubbaFromTipoIppica,
} from 'features/ippica/functions';
import { isNotEmpty, isTruthy } from 'utility/functions';

import { CountdownTimer } from 'components/countdownTimer';
import { DynamicImage, enLoading } from 'components/Image';
import { Stato } from 'features/ippica/types';
import classNames from 'classnames';
import { selectIppicaRaceDetail } from 'features/ippica/selectors';
import styles from './IppicaScommesseTablePosition.module.scss';
import { useGetCavallo } from 'features/ippica/hooks';
import useTimestamp from 'hooks/useTimestamp';
import { useTypedSelector } from 'lib/centralStore';

export type IppicaScommesseTablePositionProps = {
  timestamp?: string;
  indexCavallo?: number;
  containerClassName?: string;
  keyCavallo: string;
  isOpen: boolean;
  isReverse?: boolean;
};

export const IppicaScommesseTablePosition = ({
  timestamp,
  //  indexCavallo,
  containerClassName,
  keyCavallo,
  isOpen,
  isReverse,
}: IppicaScommesseTablePositionProps) => {
  const { codiceStatoAvvenimento, tipoIppica } = useTypedSelector(selectIppicaRaceDetail);
  //  const cavalliDict = useTypedSelector(selectCavalli);
  const { fantino, ordineArrivo, numeroCavallo, numeroGabbia } = useGetCavallo(keyCavallo);
  const { minutes, seconds } = useTimestamp(timestamp) || {};
  return (
    <div className={classNames(styles.container, containerClassName ?? '', { [styles.backgroundSelected]: isOpen })}>
      {timestamp ? (
        <CountdownTimer minutes={minutes} seconds={seconds}>
          <p className={styles.text}>Iniziata</p>
        </CountdownTimer>
      ) : (
        <>
          {(isEqualStatoScommessaByKey(codiceStatoAvvenimento, Stato.InPagamento) ||
            isEqualStatoScommessaByKey(codiceStatoAvvenimento, Stato.Chiusa)) &&
            (ordineArrivo ? <span className={styles.highlighted}>{ordineArrivo}&deg;</span> : numeroCavallo)}

          <div
            className={`${styles.position} ${isReverse ? styles.reverse : ''} ${
              isEqualStatoScommessaByKey(codiceStatoAvvenimento, Stato.Chiusa) ? styles.closed : ''
            }`}
          >
            {isEqualStatoScommessaByKey(codiceStatoAvvenimento, Stato.Aperta) && (
              <>
                {numeroCavallo}
                {isTruthy(numeroGabbia) && <span className={styles.number}>{`(${numeroGabbia})`}</span>}
              </>
            )}

            {isEqualStatoScommessaByKey(codiceStatoAvvenimento, Stato.InPagamento) && ordineArrivo && (
              <div className={styles.wrapperPosition}>
                <span className={styles.hourseNumber}> {numeroCavallo}</span>
                {numeroGabbia && <span className={styles.number}>{`(${numeroGabbia})`}</span>}
              </div>
            )}
          </div>

          {isNotEmpty(fantino?.giubbaImage?.src) &&
            isDifferentStatoScommessaByKey(codiceStatoAvvenimento, Stato.Chiusa) &&
            isDifferentStatoScommessaByKey(codiceStatoAvvenimento, Stato.InPagamento) && (
              <span className={styles.imageContainer}>
                <DynamicImage
                  src={retrieveImageGiubbaFromTipoIppica(fantino.giubbaImage.src!, tipoIppica)}
                  alt={fantino.nomeFantino ?? ''}
                  title={fantino.nomeFantino}
                  fill
                  loading={enLoading.lazy}
                  decoding="async"
                  className={styles.image}
                />
              </span>
            )}
        </>
      )}
    </div>
  );
};
